module.exports = __webpack_public_path__ + "img/ag_gallery_1.cd868c30.jpg";